<section
  class="ui-note"
  [class.ui-note-success]="isSuccess()"
  [class.ui-note-warning]="isWarning()"
  [class.ui-note-danger]="isDanger()"
  [attr.role]="role()"
>
  @if (title(); as currentTitle) {
    <h2 class="ui-note-title">{{ currentTitle }}</h2>
  }
  <div class="ui-note-body">
    <ng-content />
  </div>
</section>
